export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'